// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/hospital.js';

import { paths } from '../generated/hospital';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('hospital', Original, paths);
